export const getVideos = (state) =>
  state.videos;
